import React, { useState, useEffect } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
  TableContainer,
  Paper,
  Grid,
  TextField,
  Box,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Container,
  Typography,
  FormHelperText,
  Button,
  Tooltip,
  Dialog,
  DialogContent,
  CircularProgress,
} from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS
import "ag-grid-community/styles/ag-theme-alpine.css"; // Alpine theme CSS
import Autocomplete from "@mui/material/Autocomplete";
import { CustomPaper } from "components/Styles/globalStyles";
import Cookie from "js-cookie";
import { useNavigate } from "react-router-dom";
import URLs from "constants/urls";
import PropTypes from "prop-types";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  inputStyle,
  StyledButton,
  StyledTypography,
  StyledAgGridContainer,
  ViewButton,
  StyledButtonC,
  StyledSnackbar,
  StyledAlert,
  DeleteButton,
} from "components/StyledComponents/styledComponents.js";
import { StyledTableContainer } from "components/StyledComponents/styledComponents";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useMaterialUIController } from "context";
import ResponsiveTabs from "components/StyledComponents/styledComponents";

export default function AddEmployeeToPayroll() {
  const [controller] = useMaterialUIController(); // Get context state
  const { user } = controller; // Destructure user
  const [activeTab, setActiveTab] = useState(0);
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [companyCode, setCompanyCode] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState({});
  const [payrollStatus, setPayrollStatus] = useState("Y");
  const [employeeData, setEmployeeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [superierEmployeeData, setSuperierEmployeeData] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [levels, setLevels] = useState([]);
  const jwt_token = Cookie.get("jwt_token");
  const [selectedEmpData, setSelectedEmpData] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const [open, setOpen] = useState(false);
  const [intialRender, setRender] = useState(false);
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [employeePayRollData, setEmployeePayRollData] = useState({});
  const [selectedBankName, setSelectBankName] = useState("");
  const navigate = useNavigate();
  const MInput = inputStyle();
  const [formData, setFormData] = React.useState({
    employeeRecordId: 0,
    panNumber: "",
    bankName: "",
    bankAccountNumber: "",
    bankIfscCode: "",
    pfNumber: "",
    pfUanNumber: "",
    esiNumber: "",
    gender: "M",
    department: null,
    level: null,
    hiringDate: new Date().toISOString().split("T")[0],
    selectedLeave: [],
    basicPay: "",
  });
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [errors, setErrors] = React.useState({
    employeeRecordId: false,
    panNumber: false,
    bankAccountNumber: false,
    bankIfscCode: false,
    pfNumber: false,
    pfUanNumber: false,
    esiNumber: false,
    department: false,
    level: false,
    hiringDate: false,
    selectedLeave: false,
  });
  const resetForm = () => {
    setFormData({
      employeeRecordId: 0,
      panNumber: "",
      bankName: "",
      bankAccountNumber: "",
      bankIfscCode: "",
      pfNumber: "",
      pfUanNumber: "",
      esiNumber: "",
      gender: "",
      department: null,
      level: null,
      hiringDate: new Date().toISOString().split("T")[0],
      selectedLeave: [],
      basicPay: "",
    });
    setEditMode(false);
    setSelectedEmployee("");
  };
  const validationRules = {
    basicPay: () => true,
    employeeRecordId: () => true,
    panNumber: () => true,
    bankAccountNumber: () => true,
    bankIfscCode: () => true,
    pfNumber: () => true,
    pfUanNumber: () => true,
    esiNumber: () => true,
    department: () => true,
    level: () => true,
    hiringDate: () => true,
    selectedLeave: () => true,
  };
  // const validationRules = {
  //   basicPay: (v) => {
  //     const numericValue = parseFloat(v.toString().replace(/,/g, ""));
  //     return !isNaN(numericValue) && numericValue > 0;
  //   },
  //   employeeRecordId: (v) => v > 0 && Number.isInteger(v),
  //   panNumber: (v) => !v || /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v),
  //   bankAccountNumber: (v) => /^\d{9,18}$/.test(v),
  //   bankIfscCode: (v) => /^[A-Z]{4}0[A-Z0-9]{6}$/.test(v),
  //   pfNumber: (v) => /^[A-Za-z0-9]{10,15}$/.test(v),
  //   pfUanNumber: (v) => /^\d{12}$/.test(v),
  //   esiNumber: (v) => /^\d{17}$/.test(v),
  //   department: (v) => !!v,
  //   level: (v) => !!v,
  //   hiringDate: (v) => !!v,
  //   selectedLeave: (v) => !!v,
  // };
  const [touched, setTouched] = React.useState({
    panNumber: false,
  });
  // const fetchEmployeeData = async (companyId) => {
  //   const url = `${URLs.hrmsPayrollAddedEmployees}?companyId=${companyId}`;
  //   const options = {
  //     method: "GET",
  //     headers: {
  //       "Content-Type": "application/json",
  //       Authorization: `Bearer ${jwt_token}`,
  //     },
  //   };
  //   try {
  //     const response = await fetch(url, options);
  //     if (!response.ok) {
  //       throw new Error("Failed to fetch employee data");
  //     }
  //     const data = await response.json();
  //     if (!data || data.length === 0) {
  //       setAlert("No employees found for this company.", "info");
  //       setSuperierEmployeeData([]);
  //       return;
  //     }
  //     setSuperierEmployeeData(data);
  //   } catch (error) {
  //     console.error("Error fetching employee data:", error);
  //     setAlert("Failed to fetch employee data: " + error.message, "error");
  //     setSuperierEmployeeData([]);
  //   }
  // };
  const fetchEmployeeData = async (companyId) => {
    const url = `${URLs.hrmsPayrollAddedEmployees}?companyId=${user.companyId}`;
    const options = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwt_token}`,
      },
    };

    try {
      const response = await fetch(url, options);

      if (response.status === 204) {
        // Handle 204 No Content explicitly
        setAlert("No employees found for this company.", "info");
        setSuperierEmployeeData([]);
        return;
      }

      if (!response.ok) {
        throw new Error("Failed to fetch employee data");
      }

      const data = await response.json();

      if (!data || data.length === 0) {
        setAlert("No employees found for this company.", "info");
        setSuperierEmployeeData([]);
        return;
      }

      setSuperierEmployeeData(data);
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setAlert("Failed to fetch employee data: " + error.message, "error");
      setSuperierEmployeeData([]);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await fetch(URLs.hrmsDepartmentUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch departments");
      }

      const data = await response.json();
      if (Array.isArray(data)) {
        setDepartments(data);
      } else {
        setDepartments([]);
        throw new Error("Invalid department data received");
      }
    } catch (error) {
      console.error("Failed to fetch Departments data:", error);
      setAlert("Failed to fetch departments: " + error.message, "error");
      setDepartments([]);
    }
  };

  const fetchLeaves = async () => {
    try {
      const response = await fetch(URLs.hrmsEmpLeaveUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch leaves");
      }

      const data = await response.json();
      if (Array.isArray(data)) {
        setLeaveTypes(data);
      } else {
        setLeaveTypes([]);
        throw new Error("Invalid leave data received");
      }
    } catch (error) {
      console.error("Failed to fetch Leave data:", error);
      setAlert("Failed to fetch leaves: " + error.message, "error");
      setLeaveTypes([]);
    }
  };

  const fetchLevels = async () => {
    try {
      const response = await fetch(URLs.hrmsEmployeesLevel, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch levels");
      }

      const data = await response.json();
      if (Array.isArray(data)) {
        setLevels(data);
      } else {
        setLevels([]);
        throw new Error("Invalid level data received");
      }
    } catch (error) {
      console.error("Failed to fetch Levels data:", error);
      setAlert("Failed to fetch levels: " + error.message, "error");
      setLevels([]);
    }
  };

  const fetchBankDetails = async () => {
    try {
      const response = await fetch(URLs.hrmsBankDetailsUrl, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch bank details");
      }

      const data = await response.json();
      if (Array.isArray(data)) {
        setBankDetails(data);
      } else {
        setBankDetails([]);
        throw new Error("Invalid bank data received");
      }
    } catch (error) {
      console.error("Failed to fetch Bank details:", error);
      setAlert("Failed to fetch bank details: " + error.message, "error");
      setBankDetails([]);
    }
  };

  const fetchInitialData = async () => {
    setLoading(true);
    try {
      const results = await Promise.allSettled([
        fetchDepartments(),
        fetchLevels(),
        fetchLeaves(),
        fetchBankDetails(),
        fetchEmployeeData(user.companyId),
      ]);

      const failures = results.filter((r) => r.status === "rejected");
      if (failures.length > 0) {
        console.error("Some data fetches failed:", failures);
        setAlert("Some data failed to load. Please refresh the page.", "warning");
      }
    } catch (error) {
      console.error("Failed to fetch initial data:", error);
      setAlert("Failed to load initial data. Please refresh the page.", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchInitialData();
  }, [user.companyId]);

  const errorMessages = {
    basicPay: "Must be a positive number",
    employeeRecordId: "Must be a positive integer",
    panNumber: "Invalid PAN format (e.g., ABCDE1234F)",
    bankAccountNumber: "Invalid account number (9-18 digits)",
    bankIfscCode: "Invalid IFSC format (e.g., ABCD0123456)",
    pfNumber: "Invalid PF number format",
    pfUanNumber: "UAN must be 12 digits",
    esiNumber: "ESI number must be 17 digits",
    department: "Please select a department",
    level: "Please select a level",
    hiringDate: "Please select hiring date",
    selectedLeave: "Please select a leave type",
  };

  const formatAmount = (value) => {
    if (!value) return "";
    // Remove existing commas and non-numeric characters except decimal point
    const cleanValue = value.toString().replace(/[^0-9.]/g, "");
    // Ensure only one decimal point
    const parts = cleanValue.split(".");
    if (parts.length > 2) return parts[0] + "." + parts.slice(1).join("");
    // Format with commas for the whole number part
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let formattedValue = value;

    if (name === "basicPay") {
      // For basic pay, handle the comma separation
      const numericValue = value.replace(/,/g, "");
      if (numericValue === "" || /^\d*\.?\d*$/.test(numericValue)) {
        formattedValue = formatAmount(numericValue);
      } else {
        return; // Invalid input, don't update state
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: name === "employeeRecordId" ? Number(value) : formattedValue,
    }));

    // Only validate if the field has a validation rule
    if (validationRules[name]) {
      const valueToValidate =
        name === "basicPay" ? parseFloat(value.replace(/,/g, "")) || 0 : value;
      setErrors((prev) => ({ ...prev, [name]: !validationRules[name](valueToValidate) }));
    }
  };

  const handleAutocompleteChange = (name, value) => {
    if (name === "selectedLeave") {
      setFormData((prev) => ({
        ...prev,
        [name]: value.map((item) => item.leaveId),
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleDeleteAddPayRoll = async (empId) => {
    setLoading(true);
    try {
      const deleteUrl = `${URLs.deleteAddEmppayroll}/${empId}`;
      const response = await fetch(deleteUrl, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to delete employee");
      }

      setAlert("Employee deleted successfully", "success");
      handleDisplay(); // Refresh the grid
      setActiveTab(0); // Switch back to grid view
    } catch (error) {
      console.error("Delete error:", error);
      setAlert(error.message || "Failed to delete employee", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const payload = {
        employeeRecordId: editMode ? formData.employeeRecordId : 0,
        employeeId: editMode ? employeePayRollData.employeeId : selectedEmpData.employeeId,
        companyId: editMode ? employeePayRollData.companyId : selectedEmpData.companyId,
        departmentId: formData.department.departmentId,
        levelId: formData.level.levelId,
        leaveId: formData.selectedLeave.map((item) => item.leaveId),
        bankId: formData.bankName,
        hiringDate: formData.hiringDate,
        gender: formData.gender,
        managerEmployeeRecord: selectedEmployee.employeeId,
        basicPay: parseFloat(formData.basicPay.replace(/,/g, "")),
        employeeName: editMode
          ? employeePayRollData.employeeName
          : `${selectedEmpData.employeeFirstName} ${selectedEmpData.employeeLastName}`,
        additionalDetails: {
          employeeRecordId: formData.employeeRecordId,
          panNumber: formData.panNumber,
          bankName: selectedBankName,
          bankAccountName: formData.bankAccountNumber,
          bankIfscCode: formData.bankIfscCode,
          pfNumber: formData.pfNumber,
          pfUanNumber: formData.pfUanNumber,
          esiNumber: formData.esiNumber,
        },
      };

      const url = editMode ? URLs.hrmsUpdatePayRollUrl : URLs.addEmployeeToPayRoll;
      const method = editMode ? "PUT" : "POST";

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to submit form");
      }

      const responseText = await response.text();
      setAlert(responseText, "success");
      resetForm();
      setActiveTab(0);
      handleDisplay();
    } catch (error) {
      setAlert(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const payrollStatusOptions = [
    { label: "Yes", value: "Y" },
    { label: "No", value: "N" },
  ];

  useEffect(() => {
    handleDisplay();
  }, [selectedTabIndex]);

  useEffect(() => {
    if (activeTab === 1 && selectedEmpData?.employeeId) {
      fetchEmployeeData(user.companyId);
    }
  }, [activeTab, selectedEmpData]);

  const handleDisplay = async () => {
    setLoading(true);
    try {
      const url = `${URLs.hrmsGetEmployeedByPayRollStatus}?companyId=${
        user.companyId
      }&payRollStatus=${selectedTabIndex === 0 ? "Y" : "N"}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();

      if (Array.isArray(data)) {
        setEmployeeData(data);
      } else {
        setEmployeeData([]);
      }
    } catch (error) {
      setEmployeeData([]);
    } finally {
      setLoading(false);
    }
  };

  const tabs = [{ label: "Onboarded" }, { label: "Not Onboarded" }];

  const ActionCellRenderer = (props) => {
    const rowIndex = props.node.rowIndex;
    const rowData = props.api.getDisplayedRowAtIndex(rowIndex).data;

    const handlePayRollForm = () => {
      setActiveTab(1);
      setSelectedEmpData(rowData);
      setFormData({
        ...formData,
        employeeRecordId: 0,
        panNumber: "",
        bankName: "",
        bankAccountNumber: "",
        bankIfscCode: "",
        pfNumber: "",
        pfUanNumber: "",
        esiNumber: "",
        gender: "M",
        department: null,
        level: null,
        hiringDate: new Date().toISOString().split("T")[0],
        selectedLeave: [],
        basicPay: "",
      });
    };
    const triggerHandleEdit = () => {
      const employeeId = rowData.employeeId;
      handleEditClick(employeeId);
    };
    const handleDelete = () => {
      if (window.confirm("Are you sure you want to delete this employee?")) {
        const employeeId = rowData.employeeId;
        handleDeleteAddPayRoll(employeeId);
      }
    };

    return (
      <div>
        {rowData.payRollStatus === "Y" ? (
          <>
            <ViewButton sx={{ marginLeft: 0.7 }} type="button" onClick={triggerHandleEdit}>
              <EditIcon />
            </ViewButton>
            <DeleteButton type="button" onClick={handleDelete}>
              <DeleteIcon />
            </DeleteButton>
          </>
        ) : (
          <ViewButton type="button" onClick={handlePayRollForm}>
            Add to Payroll
          </ViewButton>
        )}
      </div>
    );
  };

  const ActionCellRendererStatus = (props) => {
    const rowIndex = props.node.rowIndex;
    const rowData = props.api.getDisplayedRowAtIndex(rowIndex).data;

    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: rowData.payRollStatus === "Y" ? "black" : "red",
            fontWeight: "bold",
          }}
        >
          {rowData.payRollStatus === "Y" ? "Onboarded" : "Not Onboarded"}
        </Typography>
      </Box>
    );
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouched((prev) => ({
      ...prev,
      [name]: true,
    }));
    setErrors((prev) => ({
      ...prev,
      [name]: !validationRules[name](formData[name]),
    }));
  };

  const genders = [
    { gender: "Male", genderId: "M" },
    { gender: "Female", genderId: "F" },
  ];

  const columns = [
    {
      headerName: "Employee Name",
      field: "employeeName",
      valueGetter: (params) =>
        `${params.data?.firstName || ""} ${params.data?.lastName || ""}`.trim(),
      sortable: true,
      filter: true,
      flex: 2,
      minWidth: 200,
    },
    {
      headerName: "Employee Id",
      field: "employeeCode",
      sortable: true,
      filter: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Role",
      field: "role.roleName",
      sortable: true,
      filter: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Email Id",
      field: "emailId",
      sortable: true,
      filter: true,
      flex: 1,
      minWidth: 150,
    },
    {
      headerName: "Status",
      field: "Status",
      cellRenderer: ActionCellRendererStatus,
      flex: 0.5,
      minWidth: 150,
    },
    {
      headerName: "Actions",
      field: "actions",
      cellRenderer: ActionCellRenderer,
      flex: 0.7,
      maxWidth: 120,
    },
  ];

  const setAlert = (msg, type) => {
    setMessage(msg);
    setAlertType(type);
    setOpen(true);
  };

  const selectedDepartment = departments.find(
    (dept) => dept.departmentId === employeePayRollData.departmentId
  );

  const selectedLevel = levels.find((lvl) => lvl.levelId === employeePayRollData.levelId);

  const handleEditClick = async (empId) => {
    setLoading(true);
    try {
      const url = `${URLs.getEmpPayRollData}${empId}`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${jwt_token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch employee data");
      }

      const data = await response.json();

      // Pre-fill the form with fetched data
      setFormData({
        employeeRecordId: data.employeeRecordId,
        panNumber: data.additionalDetails?.panNumber || "",
        bankName: data.bankId,
        bankAccountNumber: data.additionalDetails?.bankAccountName || "",
        bankIfscCode: data.additionalDetails?.bankIfscCode || "",
        pfNumber: data.additionalDetails?.pfNumber || "",
        pfUanNumber: data.additionalDetails?.pfUanNumber || "",
        esiNumber: data.additionalDetails?.esiNumber || "",
        gender: data.gender || "M",
        department: departments.find((d) => d.departmentId === data.departmentId) || null,
        level: levels.find((l) => l.levelId === data.levelId) || null,
        hiringDate: data.hiringDate || new Date().toISOString().split("T")[0],
        selectedLeave: leaveTypes.filter((lt) => data.leaveId?.includes(lt.leaveId)) || [],
        basicPay: data.basicPay?.toLocaleString() || "",
      });

      setSelectedEmployee(
        superierEmployeeData.find((emp) => emp.employeeId === data.managerEmployeeRecord) || null
      );
      setSelectBankName(bankDetails.find((bank) => bank.bankId === data.bankId)?.bankName || "");
      setEmployeePayRollData(data);
      setActiveTab(1);
      setEditMode(true);
    } catch (error) {
      console.error("Error fetching employee data:", error);
      setAlert(error.message || "Failed to fetch employee data", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashboardLayout>
      <Dialog
        open={loading}
        onClose={() => setLoading(false)}
        aria-labelledby="loading-dialog-title"
      >
        <DialogContent style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          <CircularProgress color="primary" />
          <Typography variant="h6" style={{ marginTop: "20px" }}>
            Loading, please wait...
          </Typography>
        </DialogContent>
      </Dialog>
      <StyledSnackbar
        open={open}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        severity={alertType}
      >
        <StyledAlert onClose={handleClose} severity={alertType}>
          {message}
        </StyledAlert>
      </StyledSnackbar>
      {activeTab === 0 && (
        <StyledTableContainer>
          <Box sx={{ mb: 2, display: "flex", justifyContent: "flex-start" }}>
            <ResponsiveTabs
              tabs={tabs}
              activeTab={selectedTabIndex}
              onChange={(_, newValue) => setSelectedTabIndex(newValue)}
              labelColor="secondary"
              bgColor="#e0f7fa"
            />
          </Box>
          <StyledAgGridContainer
            component={Paper}
            className="ag-theme-alpine"
            sx={{
              flexGrow: 1,
              backgroundColor: "transparent",
              boxShadow: "none",
              border: "none",
            }}
          >
            <AgGridReact
              rowData={employeeData}
              columnDefs={columns}
              pagination
              paginationPageSize={11}
            />
          </StyledAgGridContainer>
        </StyledTableContainer>
      )}
      {activeTab === 1 && (
        <StyledTableContainer
          container
          spacing={1}
          sx={{
            display: "flex",
            backgroundColor: "#ffffff",
            minHeight: "500px",
            borderRadius: "15px",
            overflow: "auto",
            width: "100%",
          }}
        >
          <Grid
            container
            spacing={1}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              margin: "auto",
            }}
          >
            <StyledSnackbar
              open={open}
              autoHideDuration={5000}
              onClose={handleClose}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              severity={alertType}
            >
              <StyledAlert onClose={handleClose} severity={alertType}>
                {message}
              </StyledAlert>
            </StyledSnackbar>
            <Grid item xs={12} md={12} lg={10}>
              <div style={{ position: "relative", width: "100%" }}>
                <StyledTypography>
                  {editMode ? "Edit Employee Financial Details" : "Employee Financial Details"}
                </StyledTypography>
                <Tooltip title="Reset">
                  <StyledButtonC onClick={resetForm}>
                    <RestartAltIcon />
                  </StyledButtonC>
                </Tooltip>
              </div>
              <Box component="form" onSubmit={handleSubmit} sx={{ mt: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6} lg={3}>
                    <Autocomplete
                      options={departments}
                      getOptionLabel={(option) => option.departmentName}
                      value={formData.department}
                      onChange={(_, value) => handleAutocompleteChange("department", value)}
                      PaperComponent={CustomPaper}
                      required
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Department"
                          error={errors.department}
                          helperText={errors.department && errorMessages.department}
                          sx={{
                            height: 43,
                            ...MInput.b,
                            "& .MuiInputBase-root": {
                              height: "100%",
                              minHeight: 43,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              color: MInput.a,
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <Autocomplete
                      options={levels}
                      getOptionLabel={(option) => option.levelName}
                      value={formData.level}
                      onChange={(_, value) => {
                        handleAutocompleteChange("level", value);
                      }}
                      PaperComponent={CustomPaper}
                      required
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Level"
                          error={errors.level}
                          helperText={errors.level && errorMessages.level}
                          sx={{
                            height: 43,
                            ...MInput.b,
                            "& .MuiInputBase-root": {
                              height: "100%",
                              minHeight: 43,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              color: MInput.a,
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <TextField
                      fullWidth
                      label="Hiring Date"
                      type="date"
                      name="hiringDate"
                      value={formData.hiringDate}
                      onChange={handleChange}
                      error={errors.hiringDate}
                      InputLabelProps={{
                        shrink: true,
                        sx: {
                          color: MInput.a,
                        },
                      }}
                      required
                      inputProps={{
                        max: new Date().toISOString().split("T")[0],
                      }}
                      sx={{
                        height: 43,
                        ...MInput.b,
                        "& .MuiInputBase-root": {
                          height: "100%",
                          minHeight: 43,
                        },
                      }}
                    />
                    {errors.hiringDate && (
                      <FormHelperText error>{errorMessages.hiringDate}</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <Autocomplete
                      multiple
                      options={leaveTypes ?? []}
                      getOptionLabel={(option) => option?.leaveName || ""}
                      value={formData.selectedLeave}
                      onChange={(_, value) =>
                        setFormData((prev) => ({ ...prev, selectedLeave: value }))
                      }
                      PaperComponent={CustomPaper}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Leave Type"
                          error={errors.selectedLeave}
                          helperText={errors.selectedLeave && errorMessages.selectedLeave}
                          sx={{
                            height: 43,
                            ...MInput.b,
                            "& .MuiInputBase-root": {
                              height: "100%",
                              minHeight: 43,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              color: MInput.a,
                            },
                          }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.leaveId === value.leaveId}
                      disableCloseOnSelect
                    />
                  </Grid>
                  <Grid item xs={12} md={6} lg={3}>
                    <Autocomplete
                      options={Array.isArray(superierEmployeeData) ? superierEmployeeData : []}
                      getOptionLabel={(option) => option?.employeeName ?? ""}
                      value={selectedEmployee ?? null}
                      onChange={(event, value) => {
                        setSelectedEmployee(value);
                      }}
                      PaperComponent={CustomPaper}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Manager"
                          required
                          sx={{
                            height: 43,
                            ...MInput.b,
                            "& .MuiInputBase-root": {
                              height: "100%",
                              minHeight: 43,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              color: MInput.a,
                            },
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={3}>
                    <Autocomplete
                      options={genders}
                      getOptionLabel={(option) => option.gender}
                      value={genders.find((g) => g.genderId === formData.gender) || null}
                      onChange={(_, value) => handleAutocompleteChange("gender", value?.genderId)}
                      PaperComponent={CustomPaper}
                      required
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Gender"
                          error={errors.selectedGender}
                          helperText={errors.selectedGender && errorMessages.selectedGender}
                          sx={{
                            height: 43,
                            ...MInput.b,
                            "& .MuiInputBase-root": {
                              height: "100%",
                              minHeight: 43,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              color: MInput.a,
                            },
                          }}
                        />
                      )}
                      isOptionEqualToValue={(option, value) => option.genderId === value?.genderId}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} lg={3}>
                    <Autocomplete
                      options={bankDetails}
                      getOptionLabel={(option) => option.bankName}
                      value={bankDetails.find((bank) => bank.bankId === formData.bankName) || null}
                      PaperComponent={CustomPaper}
                      required
                      onChange={(_, newValue) => {
                        setSelectBankName(newValue.bankName);
                        setFormData((prev) => ({
                          ...prev,
                          bankName: newValue ? newValue.bankId : "",
                        }));
                      }}
                      isOptionEqualToValue={(option, value) => option.bankId === value?.bankId}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select Bank"
                          error={errors.bankName}
                          sx={{
                            height: 43,
                            ...MInput.b,
                            "& .MuiInputBase-root": {
                              height: "100%",
                              minHeight: 43,
                            },
                          }}
                          InputLabelProps={{
                            sx: {
                              color: MInput.a,
                            },
                          }}
                        />
                      )}
                    />
                    {errors.bankName && (
                      <FormHelperText error sx={{ ml: 2 }}>
                        {errorMessages.bankName}
                      </FormHelperText>
                    )}
                  </Grid>
                  {[
                    ["Bank Account Number", "bankAccountNumber"],
                    ["Bank IFSC Code", "bankIfscCode"],
                    ["PF Number", "pfNumber"],
                    ["PF UAN Number", "pfUanNumber"],
                    ["ESI Number", "esiNumber"],
                  ].map(([label, name, type]) => (
                    <Grid item xs={12} md={4} lg={3} key={name}>
                      <TextField
                        fullWidth
                        label={label}
                        name={name}
                        type={type || "text"}
                        value={formData[name]}
                        onChange={handleChange}
                        error={errors[name]}
                        sx={MInput.b}
                        InputLabelProps={{
                          sx: {
                            color: MInput.a,
                          },
                        }}
                        inputProps={{
                          ...(name === "bankIfscCode" && { style: { textTransform: "uppercase" } }),
                          ...(name === "pfUanNumber" && { maxLength: 12 }),
                          ...(name === "esiNumber" && { maxLength: 17 }),
                        }}
                      />
                      {errors[name] && <FormHelperText error>{errorMessages[name]}</FormHelperText>}
                    </Grid>
                  ))}
                  <Grid item xs={12} md={4} lg={3}>
                    <TextField
                      fullWidth
                      label="PAN Number"
                      name="panNumber"
                      value={formData.panNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={errors.panNumber && touched.panNumber}
                      inputProps={{
                        style: { textTransform: "uppercase" },
                        maxLength: 10,
                      }}
                      sx={{
                        height: 43,
                        ...MInput.b,
                        "& .MuiInputBase-root": {
                          height: "100%",
                          minHeight: 43,
                        },
                      }}
                      InputLabelProps={{
                        sx: {
                          color: MInput.a,
                        },
                      }}
                    />
                    {errors.panNumber && touched.panNumber && (
                      <FormHelperText error>{errorMessages.panNumber}</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} md={4} lg={3}>
                    <TextField
                      fullWidth
                      label="Basic Pay"
                      name="basicPay"
                      value={formData.basicPay}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      required
                      error={Boolean(errors.basicPay) && touched.basicPay}
                      sx={MInput.b}
                      InputLabelProps={{
                        sx: {
                          color: MInput.a,
                        },
                      }}
                    />
                    {Boolean(errors.basicPay) && touched.basicPay && (
                      <FormHelperText error>{errorMessages.basicPay}</FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                      <StyledButton variant="outlined" onClick={() => setActiveTab(0)}>
                        {editMode ? "Cancel" : "Back to List"}
                      </StyledButton>
                      <StyledButton
                        type="submit"
                        variant="contained"
                        color="primary"
                        sx={{ ml: 2 }}
                        disabled={Object.values(errors).some((error) => error)}
                      >
                        {editMode ? "Update" : "Save Details"}
                      </StyledButton>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </StyledTableContainer>
      )}
    </DashboardLayout>
  );
}

AddEmployeeToPayroll.propTypes = {
  node: PropTypes.shape({
    rowIndex: PropTypes.number.isRequired,
  }).isRequired,
  api: PropTypes.shape({
    getDisplayedRowAtIndex: PropTypes.func.isRequired,
  }).isRequired,
};
